import { render, staticRenderFns } from "./LeadingNewBreadcrumbButton.component.vue?vue&type=template&id=0fa71f1b&scoped=true&"
import script from "./LeadingNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./LeadingNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./LeadingNewBreadcrumbButton.component.vue?vue&type=style&index=0&id=0fa71f1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa71f1b",
  null
  
)

export default component.exports